import { DEFAULT_LEGEND_RANGES, DEFAULT_LEGEND_UNIT_ID } from 'utils/rateMapPngRender/constants';

import { JOHN_DEERE_FIELDS_API } from 'hooks/useJohnDeereFields/constants';
import { ORGANIZATIONS_API } from 'hooks/useJohnDeereOrganizations/constants';

export { DEFAULT_LEGEND_RANGES, DEFAULT_LEGEND_UNIT_ID, JOHN_DEERE_FIELDS_API, ORGANIZATIONS_API };

export const DEFAULT_LEGEND = {
    ranges: DEFAULT_LEGEND_RANGES,
    unitId: DEFAULT_LEGEND_UNIT_ID
};
